import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Register } from "../../../api";
import { useTranslation } from "../../../../context/TranslationContext";

const StepUserInfo = ({ token, checkLogin }) => {
  const {
    registrationSuccess,
    registrationError,
    name: nameLabel,
    surname: surnameLabel,
    email: emailLabel,
    password: passwordLabel,
    completeRegistration,
    nameRequired,
    surnameRequired,
    emailRequired,
    emailInvalid,
    passwordRequired,
    passwordMin,
  } = useTranslation();

  const Step3Schema = Yup.object().shape({
    name: Yup.string().required(nameRequired),
    surname: Yup.string().required(surnameRequired),
    email: Yup.string().email(emailInvalid).required(emailRequired),
    password: Yup.string().required(passwordRequired).min(6, passwordMin),
  });

  const handleStep3Submit = async (values, actions) => {
    try {
      const data = {
        name: values.name,
        surname: values.surname,
        email: values.email,
        password: values.password,
        token: token,
      };
      const response = await Register(data, 3);
      if (response.data.error) {
        toast.error(response.data.error);
      } else {
        localStorage.setItem("reservations_auth", response.data.token || token);
        toast.success(registrationSuccess);
        checkLogin();
      }
    } catch (error) {
      toast.error(registrationError);
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ name: "", surname: "", email: "", password: "" }}
      validationSchema={Step3Schema}
      onSubmit={handleStep3Submit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit} className="mb-6">
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="relative z-0 w-full group">
              <input
                type="text"
                id="name"
                name="name"
                className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
                placeholder=" "
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.name}
              />
              <label
                htmlFor="name"
                className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
              >
                {nameLabel}
              </label>
            </div>
            <div className="relative z-0 w-full group">
              <input
                type="text"
                id="surname"
                name="surname"
                className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
                placeholder=" "
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.surname}
              />
              <label
                htmlFor="surname"
                className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
              >
                {surnameLabel}
              </label>
            </div>
          </div>
          <div className="relative z-0 mb-4 w-full group">
            <input
              type="email"
              id="email"
              name="email"
              className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
              placeholder=" "
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.email}
            />
            <label
              htmlFor="email"
              className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
            >
              {emailLabel}
            </label>
          </div>
          <div className="relative z-0 mb-6 w-full group">
            <input
              type="password"
              id="password"
              name="password"
              className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
              placeholder=" "
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.password}
            />
            <label
              htmlFor="password"
              className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
            >
              {passwordLabel}
            </label>
          </div>
          <button
            disabled={props.isSubmitting || !props.isValid || !props.dirty}
            type="submit"
            className="w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60"
          >
            {completeRegistration}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default StepUserInfo;
